import { ChakraFlex, ChakraText, EquipUITheme, Flag } from '@equip.health/ui';

const { paragraph } = EquipUITheme.typography;

type PriorityLabelProps = {
  color: string;
  title: string;
};

const PriorityLabel = ({ color, title }: PriorityLabelProps) => (
  <ChakraFlex align="center">
    <Flag fill={color} height="20px" width="20px" />
    <ChakraText {...paragraph} color="neutral.primary" marginLeft="16px">
      {title}
    </ChakraText>
  </ChakraFlex>
);

export default PriorityLabel;
